import eventHub from './event-hub';

var tools = {
    eventHub,

    myConsoleLog: (...args) => {
        const processENV = process?.env?.NODE_ENV;
        if (processENV === 'development') {
            console.log(...args);
        }
    },

    printObservable(...input) {
        let result = input.map(item => JSON.parse(JSON.stringify(item)));
        this.myConsoleLog(...result);
    },

    range() {
        let valid_args = [].slice.call(arguments)
            .filter(arg => !isNaN(Number(arg))).slice(0, 3);
        if (!valid_args.length) throw 'need at least one arguments';
        let result = [], start = 1, end, step = 1;
        if (valid_args.length === 1) {
            end = valid_args[0];
        }
        if (valid_args.length > 1) {
            start = valid_args[0];
            end = valid_args[1];
        }
        if (valid_args.length === 3) {
            step = valid_args[2]
        }
        for (let i = start; i <= end; i += step) {
            result.push(i);
        }
        return result;
    },

    intRandom() {
        let valid_args = [].slice.call(arguments)
            .filter(arg => !isNaN(Number(arg))).slice(0, 3);
        if (!valid_args.length) throw 'need at least one arguments';
        let start = 0, end;
        if (valid_args.length === 1) {
            end = valid_args[0];
        }
        if (valid_args.length > 1) {
            start = valid_args[0];
            end = valid_args[1];
        }
        return Math.floor(Math.random() * (Math.abs(end - start) + 1) + start);
    },

    dummyString(length = 20, range = '0-z') {
        if (typeof range !== 'string') return;
        let reg_rule = /^[^\s]\s*-\s*[^\s]$/, result = '';
        if (reg_rule.test(range)) {
            let start = range.charCodeAt(0),
                end = range.charCodeAt(range.length - 1);
            range = String.fromCharCode(...this.range(start, end));
        }
        for (let index = 0; index < length; index++) {
            let randpos = tools.intRandom(range.length - 1);
            result += range.charAt(randpos);
        }
        return result;
    }

};

export default tools;
